import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useAppState } from "@nosto/preact"
import { useEffect, useRef } from "preact/hooks";

import DropdownProduct from "./DropdownProduct"

export default function Autocomplete() {
    const { query } = useAppState();
    const { products, keywords } = useResponse();
    if (!products?.hits?.length && !keywords?.hits?.length) return
    const keywordsWrapRef = useRef(null);
    const inputMobileRef = useRef(null);
    const inputDesktopRef = useRef(null);

    useEffect(() => {
        if(!inputMobileRef?.current && !inputDesktopRef?.current) {
            const headerEl = document.querySelector('.header');
            if(!headerEl) return;
            inputMobileRef.current = headerEl.querySelector('.overlay input[type="search"]');
            inputDesktopRef.current = headerEl.querySelector('.header__right input[type="search"]');
        }
    }, []);

    useEffect(() => { // wishlist [FEA-11150]
        if (products?.hits?.length > 0 && window.RivoProfileAlpine) {
            const rivoAccountWidget = document.getElementById('rivo-account-slideout');
            if (rivoAccountWidget) {
                window.RivoProfileAlpine?.$data(rivoAccountWidget)?.initializeFavoriteButtons();
            }
        }
    }, [ products?.hits ])

    useEffect(() => {
        function checkMarkets(){
            if(typeof window?.Nosto?.migrateToShopifyMarket === "function"){
              window?.Nosto?.migrateToShopifyMarket({
                productSectionElement: '.nosto-product-card',
                productUrlElement: '.nosto-product-link',
                productHandleAttribute: 'data-handle',
                priceElement: '.nosto-p',
                listPriceElement: '.nosto-lp',
      
              })
             }else{
              setTimeout(checkMarkets, 1200);
            }
          }
          checkMarkets();
    })

    useEffect(() => { // close mobile search overlay when keyword clicked
        const handleKeywordClick = (event) => {
            if(
                event.target.classList.contains('ns-autocomplete-element') || 
                event.target.closest('.ns-autocomplete-element')
            ) {
                document.querySelector('.header__hamburger-menu .header__close-icon[data-search-close]')?.click();
            }
        }

        if(window.innerWidth < 1024 && keywordsWrapRef.current) {
            keywordsWrapRef.current.addEventListener('click', handleKeywordClick);
            return () => keywordsWrapRef.current.removeEventListener('click', handleKeywordClick);
        }
    }, [])

    const handleClickSubmit = (event) => {
        event.preventDefault();
        const enterEvent = new KeyboardEvent('keydown', {
            key: 'Enter', code: 'Enter',
            keyCode: 13, which: 13,
            bubbles: true, cancelable: true,
        });
        if(window.innerWidth < 1024 && inputMobileRef?.current) {
            inputMobileRef.current.focus();
            inputMobileRef.current.dispatchEvent(enterEvent);
        } else if (inputDesktopRef?.current) {
            inputDesktopRef.current.focus();
            inputDesktopRef.current.dispatchEvent(enterEvent);
        }
        window.scrollTo({ top: 0, behavior: "smooth" })
        closeSearch();
    };

    const closeSearch = () => {
        const closeSearchBtn = document.querySelector('[data-search-close].header__close-icon');
        if(closeSearchBtn) {
            closeSearchBtn.click();
        }
    };

    return (
        <div
            className="ns-autocomplete ns-suggested-autocomplete absolute left-0 right-0 inline-block mx-auto bg-white overflow-hidden"
            data-nosto-element="autocomplete"
        >
            <div className="ns-autocomplete-inner pb-16 lg:pb-0">

                {/* KEYWORDS */}
                <div className="ns-keywords-section ns-suggested pt-5">
                    {keywords?.hits?.length > 0 && (
                    <>
                        <h6 className="ns-section-header h7--medium mb-3.5">Related Search</h6>
                        <div 
                            className="list-unstyled" 
                            aria-label="Related Search" 
                            role="list" 
                            ref={keywordsWrapRef}
                            >
                            <Keywords
                                hits={keywords.hits}
                                keywordComponent={Keyword}
                                elementComponent={Element}
                                keywordInCategoryComponent={KeywordInCategory}
                                />
                        </div>
                    </>
                    )}
                </div>

                
                {/* PRODUCTS */}
                {products?.hits?.length > 0 && (
                    <div className="ns-products-section py-5">
                        <h6 className="ns-section-header h7--medium mb-3.5">Related Products</h6>
                        <div className="ns-product-list flex flex-wrap list-unstyled" aria-label="Search related products">
                            {products?.hits?.map(product => (
                                <DropdownProduct
                                    key={product.productId}
                                    product={product} 
                                />
                            ))}
                        </div>
                        {(products?.total > 0) && (
                            <button data-submit-search className="flex flex-nowrap items-center hover:underline py-4 mt-4 lg:mt-0 lg:ml-auto" type="button" onClick={handleClickSubmit}>
                                <span>
                                    See {products.total} results for "{query.query}"
                                </span>
                                <svg class="lg:mr-2.5 ns-submit-chevron" aria-hidden="true" width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Arrow down">
                                    <path d="M12 8L8 12L4 8" stroke="#2D2926" stroke-miterlimit="16" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                            </button>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement hit={hit} filter={filter} class="cursor-pointer body-2">
            {keywordComponent}
        </AutocompleteElement>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{ __html: hit._highlight.keyword }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span>
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span className="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}
